import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { orderGridCombineOrders } from '../../../store/orders/grid/orders.grid.header.actions';
import { useAdvancedSearchStatusDisabled } from '../disabled-hooks/use-advanced-search-status-disabled';
import { useMoreThanOneOrderSelectedDisabled } from '../disabled-hooks/use-more-than-one-order-selected-disabled';
import { messages } from './messages';

export const useAdvancedSearchCombine = () => {
  const dispatch = useDispatch();
  const advancedSearchStatusDisabled = useAdvancedSearchStatusDisabled();
  const moreThanOneOrderSelectedDisabled = useMoreThanOneOrderSelectedDisabled();

  const actionHandler = useCallback(() => {
    dispatch(orderGridCombineOrders());
  }, [dispatch]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsCombine,
      isDisabled: advancedSearchStatusDisabled || moreThanOneOrderSelectedDisabled,
      disabledReason: null,
    };
  }, [actionHandler, advancedSearchStatusDisabled, moreThanOneOrderSelectedDisabled]);
};
